import React, { useEffect } from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { CContainer, CHeaderNav } from '@coreui/react';
import { useDispatch, useSelector } from 'react-redux';
import DashboardPage from '../dashboard/containers/DashboardPage';
import InsightsPage from '../insights/components/InsightsPage';
import TechniciansPage from '../technicians/components/TechniciansPage';
import JobsPage from '../jobs/components/JobsPage';
import InternalSignUp from '../i-admin/containers/InternalSignUp';
import ProfilePage from '../profile/containers/ProfilePage';
import CustomizationPage from '../customization/containers/CustomizationPage';
import SearchForm from './SearchForm';
import ErrorLayout from './ErrorLayout';
import { isInactiveSubscription } from '../shared/utils/chargebee-utils';
import { selectUserOrganization } from '../store/selectors/store.selectors';
import ChatPage from '../chat/containers/ChatPage';
import { selectCanAccessCustomization, selectJourneyConfigChatEnabled } from '../store/selectors/journey.selectors';
import OrgHierarchyPrivateRoute from '../routes/OrgHierarchyPrivateRoute';
import RootPrivateRoute from '../routes/RootPrivateRoute';
import { SyncChatChannels } from '../chat/actions/chat.action';
import { selectChatState } from '../chat/selectors/chat.selector';

const GeneralLayoutContent = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const org = useSelector(selectUserOrganization);
  const chatEnabled = useSelector(selectJourneyConfigChatEnabled);
  const canAccessCustomization = useSelector(selectCanAccessCustomization);
  const chatState = useSelector(selectChatState);
  const {
    enableCustomizationModule,
    enableInsightsModule,
    enableJobsModule,
    enableDashboardModule,
    enableTechniciansModule,
    enableChargebeeModule,
    enableChatModule,
    enableSearchModule,
  } = useFlags();

  useEffect(() => {
    if (enableChatModule && chatEnabled && chatState?.connected) {
      dispatch(new SyncChatChannels());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return (
    <main className="c-main glympser-main">
      <CContainer fluid>
        { enableChargebeeModule && <ErrorLayout /> }
        <Switch>
          <Route exact path='/'>
            { (!enableChargebeeModule || !isInactiveSubscription(org)) && enableDashboardModule ? <Redirect to='/dashboard' /> : <Redirect to='/profile' /> }
          </Route>
          {
            (!enableChargebeeModule || !isInactiveSubscription(org)) && enableInsightsModule && <Route path='/insights'>
              <InsightsPage />
            </Route>
          }
          {
            (!enableChargebeeModule || !isInactiveSubscription(org)) && enableJobsModule && <Route path='/jobs'>
              <JobsPage />
            </Route>
          }
          {
            (!enableChargebeeModule || !isInactiveSubscription(org)) && enableTechniciansModule && <Route path='/technicians'>
              <TechniciansPage />
            </Route>
          }
          <Route path='/profile'>
            <ProfilePage />
          </Route>
          {
            (!enableChargebeeModule || !isInactiveSubscription(org)) && enableCustomizationModule && canAccessCustomization && <Route path='/customize'>
              <CustomizationPage />
            </Route>
          }
          {
            (!enableChargebeeModule || !isInactiveSubscription(org)) && enableChatModule && chatEnabled && <Route path='/chat'>
              <ChatPage />
            </Route>
          }
          <RootPrivateRoute path='/internal-sign-up'>
            <InternalSignUp />
          </RootPrivateRoute>
          <OrgHierarchyPrivateRoute path="*">
            {
              (!enableChargebeeModule || !isInactiveSubscription(org)) && enableDashboardModule && <Route path='/dashboard'>
                {
                  enableSearchModule && (
                    <CHeaderNav className="glympse-searchBar" >
                      <SearchForm />
                    </CHeaderNav>
                  )
                }
                <DashboardPage />
              </Route>
            }
          </OrgHierarchyPrivateRoute>
          <Route path='*'>
            Page doesnt exist
          </Route>
        </Switch>
      </CContainer>
    </main>
  )
}

export default React.memo(GeneralLayoutContent)
